import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function getChargeApprovalWorkOrder({ id, params }) {
  return BaseService.get(REST.CHARGE_APPROVAL_WORK_ORDER_ID(id), {
    params: paramsFilter({ params }),
  });
}

function postChargeApprovalWorkOrder({ body }) {
  return BaseService.post(REST.CHARGE_APPROVAL_WORK_ORDER, body);
}

function deleteChargeApprovalWorkOrder({ body }) {
  return BaseService.delete(REST.CHARGE_APPROVAL_WORK_ORDER, {
    data: body,
  });
}

export default {
  postChargeApprovalWorkOrder,
  deleteChargeApprovalWorkOrder,
  getChargeApprovalWorkOrder,
};
